<div class="flex std-mt">
  <div *ngIf="question.image">
			<div class="question-image">
				<img src="{{question.image}}">
			</div>
		</div>
  <div>
    <h3 class="no-m">{{question.question_text}}</h3>
    <p class="no-mt sm-mb" *ngIf="question.question_note"><em>{{question.question_note}}</em></p>
    <ul class="no-m">
      <li *ngFor="let a of question.answers">{{a.original}}</li>
    </ul>
  </div>
</div>
<p class="response-header">
	<span>Responses: </span>
	<span [ngClass]="{'sim-link': viewBy === 'team'}" (click)="viewBy = 'answer'">{{reviewMode ? 'Incorrect' : 'By Answer'}}</span>
	<span> / </span>
	<span [ngClass]="{'sim-link': viewBy === 'answer'}" (click)="viewBy = 'team'">By Team</span>
</p>
<div *ngIf="viewBy === 'answer'">
	<app-score-answer
		*ngFor="let uv of game | uniqueAnswers:question:round.round_id:q_idx:game.resetter"
		[uv]="uv"
		[question]="question"
		[round]="round"
		[game]="game"
		[viewOnly]="reviewMode"
		[reviewMode]="reviewMode"
		[hideCorrect]="reviewMode"
		(reset)="processReset()"></app-score-answer>
</div>
<div *ngIf="viewBy === 'team'">
	<div *ngFor="let t of game.getQuestionResponses(round.round_id, q_idx)" class="md-p sm-mb team-answer-box">
		<h3 class="no-mt md-mb">{{t.team_name}}</h3>
		<app-score-answer
			*ngFor="let a of t.answers | correctTeamAnswersByQuestion:question"
			[uv]="a"
			[question]="question"
			[round]="round"
			[game]="game"
			[viewOnly]="true"
			[reviewMode]="reviewMode"
			(reset)="processReset()"></app-score-answer>
	</div>
</div>
